/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Error/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import NoSearchResult from 'DesignSystem/Images/NoSearchResult/index'
import React from 'react'
import SupportLink from './SupportLink/index'
import TagLabel from 'DesignSystem/TagLabel/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function Error({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Relations/AddRelation/Search/Content/Profiles/Error"
  
}) {
  let isBefore = useIsBefore()
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
  return (<React.Fragment
>
<div
  data-testid="Error.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-4QcjJ': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<NoSearchResult
  viewPath={`${viewPath}/NoSearchResult`}
 width={150}
 height="auto"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 paddingTop={dtSpaceXs}
 paddingBottom={dtSpaceXs}
 color={dtColorsNeutral600}
 fontSize={28}
 marginTop={dtSpaceM}
 text="No matches found"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXs}
 color={dtColorsNeutral600}
 marginTop={dtSpaceM}
 fontSize={dtTypographyFontsizeM}
 text="Try these formats to refine your search:"
/>
<div
  data-testid="Error.Vertical:1"
  data-view-path={viewPath}
 style={{'--mt-2-4QcjJ': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical1}`}
>
<TagLabel
  viewPath={`${viewPath}/TagLabel`}
 tagText="MM/DD/YYYY"
 labelText="Date of birth"
/>
<TagLabel
  viewPath={`${viewPath}/TagLabel`}
 marginTop={4}
 tagText="(123) 123-1234"
 labelText="Phone number"
/>
<TagLabel
  viewPath={`${viewPath}/TagLabel`}
 marginTop={4}
 tagText="1234a"
 labelText="Human ID"
/>
</div>
<SupportLink
  viewPath={`${viewPath}/SupportLink`}
/>
</div>
{children}
</React.Fragment>)
}